import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle<{ $reduceMotion?: boolean }>`
  :root {
    --interaction-duration: ${({ $reduceMotion }) => ($reduceMotion ? '0ms' : '160ms')};
    --control-hover-scale: ${({ $reduceMotion }) => ($reduceMotion ? 1 : 1.025)};
    --control-selected-scale: ${({ $reduceMotion }) => ($reduceMotion ? 1 : 1.015)};
    --card-hover-scale: ${({ $reduceMotion }) => ($reduceMotion ? 1 : 1.004)};
  }
  *, *::before, *::after { box-sizing: border-box; }
  html, body, #root { height: 100%; }
  body {
    margin: 0;
    background: ${({ theme }) => theme.color.bgRoot};
    color: ${({ theme }) => theme.color.textPrimary};
    font-family: ${({ theme }) => theme.font.body};
    font-size: ${({ theme }) => theme.fontSize.md};
    line-height: ${({ theme }) => theme.lineHeight.md};
    /* Per-mode optical weight: light text on a dark ground blooms and reads
       thinner, so dark mode sets 430 against light mode's 400. */
    font-weight: ${({ theme }) => theme.font.bodyWeight};
    /* NOT tabular-nums here. It looked like the obvious global default, and in
       this typeface the feature also widens the period and comma to digit
       width (so "1,234.56" aligns in a column), which put a visible gap
       before every full stop in running prose. Tabular figures belong on
       DATA, and every mono block sets it locally. */
    transition: background 200ms ease, color 200ms ease;
  }
  /* Accessibility: Underline-links pref (Settings → Accessibility). Additive only:
     when off, anchors keep whatever styling their component gives them. */
  ${({ theme }) => (theme.underlineLinks ? 'a { text-decoration: underline !important; }' : '')}
  :focus { outline: none; }
  /* One focus rule for the whole app: a 2px accent ring held 2px off the
     element. The offset gap is load-bearing: the Card Appearance system lets a
     member seed their own card colour, so a ring drawn flush against the
     surface can land on a near-identical lightness and disappear. */
  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
  }
  /* onAccent is solved per accent (dark text on the light dark-mode damson,
     white on the deep light-mode one), so selected text tracks the accent
     instead of a stale literal. The old hardcoded #04121a sat at ~1.6:1 on the
     light theme's deep violet, so selected text was effectively unreadable. */
  ::selection {
    background: ${({ theme }) => theme.color.accentCyan};
    color: ${({ theme }) => theme.color.onAccent};
  }
`;
